// $mobile in app.scss: where a note covers the list
const MOBILE = '(max-width: 43.75rem)';

export const isMobile = () => matchMedia(MOBILE).matches;
